

import ProjectDataForModal from '@/entities/modals/ProjectDataForModal';
import NewlyCreatedSchedulerItem from '@/entities/scheduler/NewlyCreatedSchedulerItem';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import ProjectModal from "@/components/companyProjects/ProjectModal.vue";
import RouteParams from '@/entities/RouteParams';
import RouteNames from '@/entities/RouteNames';
import SchedulerCustomModalHeader from "@/components/scheduler/SchedulerCustomModalHeader.vue";
import ActivityDataForModal from '@/entities/modals/ActivityDataForModal';
import ActivityFormModal from "@/components/projects/activities/ActivityFormModal.vue";

@Component({
    components: {
        ProjectModal,
        SchedulerCustomModalHeader,
        ActivityFormModal
    },
})
export default class AddActivity extends Vue {
    @Prop({ type: String, default: null }) readonly type!: string;
    @Prop({ type: String, default: null }) readonly message!: string;
    @Prop({ type: String, default: null }) readonly companyId!: string;
    @Prop({ type: Object, default: null }) readonly currentUser!: any;
    @Prop({ type: String, default: null }) readonly managerId!: any;
    @Prop({ type: Object, default: null }) readonly project!: any;

    modalShown: boolean = false;
    projectInfoForModal?: ProjectDataForModal | null = null;
    showProjectModal = false;
    showActivityModal = false;
    isEdittingLocked: boolean = false;
    newlyCreatedItemId?: string = undefined;
    activityInfoForModal?: ActivityDataForModal | null = null;

    handleCreateBtnClicked() {
        if (this.type == 'project') {
            this.showProjectModal = true;
            this.modalShown = true;
            this.projectInfoForModal = {
                company_id: this.companyId,
                manager_id: this.managerId,
                start_date: "",
                end_date: "",
                name: undefined,
                min_budget: null,
                max_budget: null,
                isNew: true,
            };
        } else {
            this.showActivityModal = true;
            this.projectInfoForModal = this.project;
            this.modalShown = true;
            this.activityInfoForModal = {
                title: "",
                start_date: "",
                end_date: "",
                note: "",
                budget: "",
                confirmed_hours: 0,
                requested_hours: 0,
                isNew: true,
            };
        }
    }

    handleEditClick(): void {
        this.isEdittingLocked = false;
    }

    get linkToProject(): RouteParams<{ id: string }> {
        return {
            name: RouteNames.PROJECT_ACTIVITY,
            params: { id: "" }
        }
    }
    get linkToProjectActivities(): RouteParams<{ id: string }> {
        return {
            name: RouteNames.PROJECT_ACTIVITY,
            params: { id: this.projectInfoForModal?.id || "" }
        }
    }

    get shouldBlockEditting(): boolean {
        return this.isEdittingLocked && !Boolean(this.activityInfoForModal?.isNew);
    }

    async handleCollectionUpdated(): Promise<void> {
        this.clearNewlyCreatedItemId();
        // this.clearSelectedItems();
        await this.refetchCollection();
        this.closeModal();
    }

    refetchCollection(): void {
        this.$emit('refetchCollection');
    }
    handleCloseModal(): void {
        if (this.modalShown == false) {
            return;
        }
        if (this.newlyCreatedItemId) {
            this.clearNewlyCreatedItemId();
        }
        this.closeModal();
    }

    closeModal(): void {
        this.modalShown = false;
        this.isEdittingLocked = true;
        this.showProjectModal = false;
        this.showActivityModal = false;
    }

    clearNewlyCreatedItemId(): void {
        this.newlyCreatedItemId = undefined;
    }
}
